// Settings configured here will be merged into the final config object.
export default {
  ACCOUNT_KEY: 'rh3NGFHghsveJru9JDygcrSzG58oNLzk',
  // Set to 'docked' or 'normal' for docked or normal mode respectively
  THEME: 'normal',
};
